/* tslint:disable */
/* eslint-disable */
/**
 * CMS
 * The CMS API description
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosResponse, AxiosInstance, AxiosRequestConfig } from "axios";
// @ts-ignore
import globalAxios from "@/config/axiosInstance";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
import { Number12 } from "../models";
/**
 * ArtistApi - axios parameter creator
 * @export
 */
export const ArtistApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} farsiName
     * @param {string} englishName
     * @param {string} description
     * @param {string} slug
     * @param {string} nationality
     * @param {string} profession
     * @param {boolean} isAnaVatan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    artistControllerCreateArtistForm: async (
      farsiName: string,
      englishName: string,
      description: string,
      slug: string,
      nationality: string,
      profession: string,
      isAnaVatan: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'farsiName' is not null or undefined
      if (farsiName === null || farsiName === undefined) {
        throw new RequiredError(
          "farsiName",
          "Required parameter farsiName was null or undefined when calling artistControllerCreateArtistForm."
        );
      }
      // verify required parameter 'englishName' is not null or undefined
      if (englishName === null || englishName === undefined) {
        throw new RequiredError(
          "englishName",
          "Required parameter englishName was null or undefined when calling artistControllerCreateArtistForm."
        );
      }
      // verify required parameter 'description' is not null or undefined
      if (description === null || description === undefined) {
        throw new RequiredError(
          "description",
          "Required parameter description was null or undefined when calling artistControllerCreateArtistForm."
        );
      }
      // verify required parameter 'slug' is not null or undefined
      if (slug === null || slug === undefined) {
        throw new RequiredError(
          "slug",
          "Required parameter slug was null or undefined when calling artistControllerCreateArtistForm."
        );
      }
      // verify required parameter 'nationality' is not null or undefined
      if (nationality === null || nationality === undefined) {
        throw new RequiredError(
          "nationality",
          "Required parameter nationality was null or undefined when calling artistControllerCreateArtistForm."
        );
      }
      // verify required parameter 'profession' is not null or undefined
      if (profession === null || profession === undefined) {
        throw new RequiredError(
          "profession",
          "Required parameter profession was null or undefined when calling artistControllerCreateArtistForm."
        );
      }
      // verify required parameter 'isAnaVatan' is not null or undefined
      if (isAnaVatan === null || isAnaVatan === undefined) {
        throw new RequiredError(
          "isAnaVatan",
          "Required parameter isAnaVatan was null or undefined when calling artistControllerCreateArtistForm."
        );
      }
      const localVarPath = `/v1/cms/api/artist`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (farsiName !== undefined) {
        localVarFormParams.append("farsiName", farsiName as any);
      }

      if (englishName !== undefined) {
        localVarFormParams.append("englishName", englishName as any);
      }

      if (description !== undefined) {
        localVarFormParams.append("description", description as any);
      }

      if (slug !== undefined) {
        localVarFormParams.append("slug", slug as any);
      }

      if (nationality !== undefined) {
        localVarFormParams.append("nationality", nationality as any);
      }

      if (profession !== undefined) {
        localVarFormParams.append("profession", profession as any);
      }

      if (isAnaVatan !== undefined) {
        localVarFormParams.append("isAnaVatan", isAnaVatan as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [id]
     * @param {string} [farsiName]
     * @param {string} [slug]
     * @param {Number12} [status]
     * @param {boolean} [isAnaVatan]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    artistControllerGetArtist: async (
      pageNumber: number,
      pageIndex: number,
      id?: string,
      farsiName?: string,
      slug?: string,
      status?: Number12,
      isAnaVatan?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'pageNumber' is not null or undefined
      if (pageNumber === null || pageNumber === undefined) {
        throw new RequiredError(
          "pageNumber",
          "Required parameter pageNumber was null or undefined when calling artistControllerGetArtist."
        );
      }
      // verify required parameter 'pageIndex' is not null or undefined
      if (pageIndex === null || pageIndex === undefined) {
        throw new RequiredError(
          "pageIndex",
          "Required parameter pageIndex was null or undefined when calling artistControllerGetArtist."
        );
      }
      const localVarPath = `/v1/cms/api/artist`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (pageNumber !== undefined) {
        localVarQueryParameter["pageNumber"] = pageNumber;
      }

      if (pageIndex !== undefined) {
        localVarQueryParameter["pageIndex"] = pageIndex;
      }

      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      if (farsiName !== undefined) {
        localVarQueryParameter["farsiName"] = farsiName;
      }

      if (slug !== undefined) {
        localVarQueryParameter["slug"] = slug;
      }

      if (status !== undefined) {
        localVarQueryParameter["status"] = status;
      }

      if (isAnaVatan !== undefined) {
        localVarQueryParameter["isAnaVatan"] = isAnaVatan;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    artistControllerGetArtistMedia: async (
      filename: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'filename' is not null or undefined
      if (filename === null || filename === undefined) {
        throw new RequiredError(
          "filename",
          "Required parameter filename was null or undefined when calling artistControllerGetArtistMedia."
        );
      }
      const localVarPath = `/v1/cms/api/artist-media/{filename}`.replace(
        `{${"filename"}}`,
        encodeURIComponent(String(filename))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} farsiName
     * @param {string} englishName
     * @param {string} description
     * @param {string} slug
     * @param {string} nationality
     * @param {string} profession
     * @param {Number12} status
     * @param {boolean} isAnaVatan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    artistControllerUpdateArtistForm: async (
      farsiName: string,
      englishName: string,
      description: string,
      slug: string,
      nationality: string,
      profession: string,
      status: Number12,
      isAnaVatan: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'farsiName' is not null or undefined
      if (farsiName === null || farsiName === undefined) {
        throw new RequiredError(
          "farsiName",
          "Required parameter farsiName was null or undefined when calling artistControllerUpdateArtistForm."
        );
      }
      // verify required parameter 'englishName' is not null or undefined
      if (englishName === null || englishName === undefined) {
        throw new RequiredError(
          "englishName",
          "Required parameter englishName was null or undefined when calling artistControllerUpdateArtistForm."
        );
      }
      // verify required parameter 'description' is not null or undefined
      if (description === null || description === undefined) {
        throw new RequiredError(
          "description",
          "Required parameter description was null or undefined when calling artistControllerUpdateArtistForm."
        );
      }
      // verify required parameter 'slug' is not null or undefined
      if (slug === null || slug === undefined) {
        throw new RequiredError(
          "slug",
          "Required parameter slug was null or undefined when calling artistControllerUpdateArtistForm."
        );
      }
      // verify required parameter 'nationality' is not null or undefined
      if (nationality === null || nationality === undefined) {
        throw new RequiredError(
          "nationality",
          "Required parameter nationality was null or undefined when calling artistControllerUpdateArtistForm."
        );
      }
      // verify required parameter 'profession' is not null or undefined
      if (profession === null || profession === undefined) {
        throw new RequiredError(
          "profession",
          "Required parameter profession was null or undefined when calling artistControllerUpdateArtistForm."
        );
      }
      // verify required parameter 'status' is not null or undefined
      if (status === null || status === undefined) {
        throw new RequiredError(
          "status",
          "Required parameter status was null or undefined when calling artistControllerUpdateArtistForm."
        );
      }
      // verify required parameter 'isAnaVatan' is not null or undefined
      if (isAnaVatan === null || isAnaVatan === undefined) {
        throw new RequiredError(
          "isAnaVatan",
          "Required parameter isAnaVatan was null or undefined when calling artistControllerUpdateArtistForm."
        );
      }
      const localVarPath = `/v1/cms/api/artist`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, "https://example.com");
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new FormData();

      if (farsiName !== undefined) {
        localVarFormParams.append("farsiName", farsiName as any);
      }

      if (englishName !== undefined) {
        localVarFormParams.append("englishName", englishName as any);
      }

      if (description !== undefined) {
        localVarFormParams.append("description", description as any);
      }

      if (slug !== undefined) {
        localVarFormParams.append("slug", slug as any);
      }

      if (nationality !== undefined) {
        localVarFormParams.append("nationality", nationality as any);
      }

      if (profession !== undefined) {
        localVarFormParams.append("profession", profession as any);
      }

      if (status !== undefined) {
        localVarFormParams.append("status", status as any);
      }

      if (isAnaVatan !== undefined) {
        localVarFormParams.append("isAnaVatan", isAnaVatan as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";
      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ArtistApi - functional programming interface
 * @export
 */
export const ArtistApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} farsiName
     * @param {string} englishName
     * @param {string} description
     * @param {string} slug
     * @param {string} nationality
     * @param {string} profession
     * @param {boolean} isAnaVatan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async artistControllerCreateArtistForm(
      farsiName: string,
      englishName: string,
      description: string,
      slug: string,
      nationality: string,
      profession: string,
      isAnaVatan: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ArtistApiAxiosParamCreator(
        configuration
      ).artistControllerCreateArtistForm(
        farsiName,
        englishName,
        description,
        slug,
        nationality,
        profession,
        isAnaVatan,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [id]
     * @param {string} [farsiName]
     * @param {string} [slug]
     * @param {Number12} [status]
     * @param {boolean} [isAnaVatan]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async artistControllerGetArtist(
      pageNumber: number,
      pageIndex: number,
      id?: string,
      farsiName?: string,
      slug?: string,
      status?: Number12,
      isAnaVatan?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ArtistApiAxiosParamCreator(
        configuration
      ).artistControllerGetArtist(
        pageNumber,
        pageIndex,
        id,
        farsiName,
        slug,
        status,
        isAnaVatan,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async artistControllerGetArtistMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ArtistApiAxiosParamCreator(
        configuration
      ).artistControllerGetArtistMedia(filename, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} farsiName
     * @param {string} englishName
     * @param {string} description
     * @param {string} slug
     * @param {string} nationality
     * @param {string} profession
     * @param {Number12} status
     * @param {boolean} isAnaVatan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async artistControllerUpdateArtistForm(
      farsiName: string,
      englishName: string,
      description: string,
      slug: string,
      nationality: string,
      profession: string,
      status: Number12,
      isAnaVatan: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await ArtistApiAxiosParamCreator(
        configuration
      ).artistControllerUpdateArtistForm(
        farsiName,
        englishName,
        description,
        slug,
        nationality,
        profession,
        status,
        isAnaVatan,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * ArtistApi - factory interface
 * @export
 */
export const ArtistApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} farsiName
     * @param {string} englishName
     * @param {string} description
     * @param {string} slug
     * @param {string} nationality
     * @param {string} profession
     * @param {boolean} isAnaVatan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async artistControllerCreateArtistForm(
      farsiName: string,
      englishName: string,
      description: string,
      slug: string,
      nationality: string,
      profession: string,
      isAnaVatan: boolean,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ArtistApiFp(configuration)
        .artistControllerCreateArtistForm(
          farsiName,
          englishName,
          description,
          slug,
          nationality,
          profession,
          isAnaVatan,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} pageNumber
     * @param {number} pageIndex
     * @param {string} [id]
     * @param {string} [farsiName]
     * @param {string} [slug]
     * @param {Number12} [status]
     * @param {boolean} [isAnaVatan]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async artistControllerGetArtist(
      pageNumber: number,
      pageIndex: number,
      id?: string,
      farsiName?: string,
      slug?: string,
      status?: Number12,
      isAnaVatan?: boolean,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ArtistApiFp(configuration)
        .artistControllerGetArtist(
          pageNumber,
          pageIndex,
          id,
          farsiName,
          slug,
          status,
          isAnaVatan,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} filename
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async artistControllerGetArtistMedia(
      filename: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ArtistApiFp(configuration)
        .artistControllerGetArtistMedia(filename, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} farsiName
     * @param {string} englishName
     * @param {string} description
     * @param {string} slug
     * @param {string} nationality
     * @param {string} profession
     * @param {Number12} status
     * @param {boolean} isAnaVatan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async artistControllerUpdateArtistForm(
      farsiName: string,
      englishName: string,
      description: string,
      slug: string,
      nationality: string,
      profession: string,
      status: Number12,
      isAnaVatan: boolean,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return ArtistApiFp(configuration)
        .artistControllerUpdateArtistForm(
          farsiName,
          englishName,
          description,
          slug,
          nationality,
          profession,
          status,
          isAnaVatan,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ArtistApi - object-oriented interface
 * @export
 * @class ArtistApi
 * @extends {BaseAPI}
 */
export class ArtistApi extends BaseAPI {
  /**
   *
   * @param {string} farsiName
   * @param {string} englishName
   * @param {string} description
   * @param {string} slug
   * @param {string} nationality
   * @param {string} profession
   * @param {boolean} isAnaVatan
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ArtistApi
   */
  public async artistControllerCreateArtistForm(
    farsiName: string,
    englishName: string,
    description: string,
    slug: string,
    nationality: string,
    profession: string,
    isAnaVatan: boolean,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ArtistApiFp(this.configuration)
      .artistControllerCreateArtistForm(
        farsiName,
        englishName,
        description,
        slug,
        nationality,
        profession,
        isAnaVatan,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {number} pageNumber
   * @param {number} pageIndex
   * @param {string} [id]
   * @param {string} [farsiName]
   * @param {string} [slug]
   * @param {Number12} [status]
   * @param {boolean} [isAnaVatan]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ArtistApi
   */
  public async artistControllerGetArtist(
    pageNumber: number,
    pageIndex: number,
    id?: string,
    farsiName?: string,
    slug?: string,
    status?: Number12,
    isAnaVatan?: boolean,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ArtistApiFp(this.configuration)
      .artistControllerGetArtist(
        pageNumber,
        pageIndex,
        id,
        farsiName,
        slug,
        status,
        isAnaVatan,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} filename
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ArtistApi
   */
  public async artistControllerGetArtistMedia(
    filename: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ArtistApiFp(this.configuration)
      .artistControllerGetArtistMedia(filename, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {string} farsiName
   * @param {string} englishName
   * @param {string} description
   * @param {string} slug
   * @param {string} nationality
   * @param {string} profession
   * @param {Number12} status
   * @param {boolean} isAnaVatan
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ArtistApi
   */
  public async artistControllerUpdateArtistForm(
    farsiName: string,
    englishName: string,
    description: string,
    slug: string,
    nationality: string,
    profession: string,
    status: Number12,
    isAnaVatan: boolean,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return ArtistApiFp(this.configuration)
      .artistControllerUpdateArtistForm(
        farsiName,
        englishName,
        description,
        slug,
        nationality,
        profession,
        status,
        isAnaVatan,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
